module.exports = __webpack_public_path__ + "static/img/new-66.e84c82b7.jpg";